import React from "react";
import Layout from "./layout/Layout.jsx";
import { LayoutProvider } from "@layout";
import { i18n } from "@corejs";
import { Loader } from "@mantine/core";
import { Api_Architecture } from "../../constants/SubApi.js";
import api, { Api_Base } from "./services/ApiService";

function App() {
	const [loading, setLoading] = React.useState(true);
	React.useEffect(() => {
		async function loadTranslations() {
			const languages = ["en", "ar"];

			for (const lang of languages) {
				try {
					const res = await fetch(`${Api_Base}local/${lang}.json`);
					if (!res) throw new Error("");
					const data = await res.json();
					if (!data) throw new Error("");
					i18n.addResourceBundle(lang, "translation", data, true, true);
				} catch (er) {
					console.warn(`failed to load '${lang}' language`);
					continue;
				}
			}

			await i18n.changeLanguage("en");
			setLoading(false);
		}

		async function init() {
			await loadTranslations();
			try {
				const arch = await api.get(Api_Architecture);
				if (arch) {
					try {
						localStorage.setItem("architecture", JSON.stringify(arch));
						if (arch.token) localStorage.setItem("token", arch.token);
					} catch (e) {
						console.warn("failed to save architecture to localStorage", e);
					}
				}
			} catch (er) {
				console.warn("failed to load architecture", er);
			}
		}

		init();
	}, []);

	return loading ? (
		<div className="h-dvh w-dvw grid place-items-center dark:bg-gray-500">
			<Loader color="blue" type="bars" />
		</div>
	) : (
		<LayoutProvider>
			<Layout />
		</LayoutProvider>
	);
}

export default App;

